module.exports = __webpack_public_path__ + "img/motor_no46.899a29f5.jpg";